import React from 'react';
import {useFetchSession} from '../hooks/auth';
import {WithChildren} from '../types/helpers';
import {PageLoader} from '../ui-kit/Loader';

const CurrentUser: React.FC<WithChildren> = ({children}) => {
  const session = useFetchSession();
  if (session?.loading) return <PageLoader />;

  return children as React.ReactElement;
};

export default CurrentUser;
